import { useQuery } from 'react-query';
import { getCostCenterSortorder } from 'RestAPIs/cost-centers/sortorder';

const useGetCostCenterSortorder = (
  costCenterId: number,
  referenceDate: string
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['costCenterSortorder', 'list', costCenterId, referenceDate],
    async () => {
      const { data } = await getCostCenterSortorder({
        costCenterId,
        referenceDate
      });
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetCostCenterSortorder;
